export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Emoji-Gray-6ef5df02221c247cc5fb8e315af2253e.svg";